"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlanPeriodEnum = void 0;
var PlanPeriodEnum;
(function (PlanPeriodEnum) {
  /** сутки */
  PlanPeriodEnum[PlanPeriodEnum["day"] = 1] = "day";
  /** месяц */
  PlanPeriodEnum[PlanPeriodEnum["month1"] = 2] = "month1";
  /** три месяца */
  PlanPeriodEnum[PlanPeriodEnum["month3"] = 3] = "month3";
  /** шесть месяцев */
  PlanPeriodEnum[PlanPeriodEnum["month6"] = 4] = "month6";
  /** год */
  PlanPeriodEnum[PlanPeriodEnum["year"] = 5] = "year";
  /** 30 минут (пригодится для тестов) */
  PlanPeriodEnum[PlanPeriodEnum["minutes30"] = 100] = "minutes30";
  /** 2 дня */
  PlanPeriodEnum[PlanPeriodEnum["day2"] = 101] = "day2";
})(PlanPeriodEnum = exports.PlanPeriodEnum || (exports.PlanPeriodEnum = {}));
